import { gql } from '@apollo/client';

export const SEND_CONTACT_MESSAGE = gql`
  mutation sendContactMessage($messageInput: MessageInput) {
    messageCalixUser(input: $messageInput)
  }
`;
